


















import Vue from 'vue'
import SectionTitle from '@/product/components/SectionTitle.vue'
import FastShippingTooltip from '@/product/components/FastShippingTooltip.vue'
import BuyingOptions from '@/product/components/BuyingOptions.vue'
import { BuyingOption, ProductState } from '@/product/types'
import { SHIPPING_OPTIONS } from '@/product/const'

export default Vue.extend({
  components: {
    SectionTitle,
    FastShippingTooltip,
    BuyingOptions
  },
  computed: {
    productState(): ProductState {
      return this.$store.state
    },
    isFastShippingSelected(): boolean {
      return this.$store.getters.isFastShippingSelected
    },
    shippingOptions(): BuyingOption[] {
      const supportPrintingFastShipping = this.productState.productDetail.product.printingFastShipping
      const supportPlainGoodFastShipping = this.productState.productDetail.product.plainGoodFastShipping
      return [
        {
          displayName: '通常出荷',
          isDisabled: false,
          isBuying: SHIPPING_OPTIONS.NORMAL
        },
        {
          displayName: '翌日出荷',
          subText: `1着 +${this.productState.productDetail.product.fastShippingMarkup || 0}円(税込)`,
          isDisabled: !this.productState.isPrintingSelected,
          isHidden: !supportPrintingFastShipping,
          isBuying: SHIPPING_OPTIONS.NEXT_DAY
        },
        {
          displayName: '当日出荷',
          subText: `1着 +${this.productState.productDetail.product.plainGoodFastShippingMarkup || 0}円(税込)`,
          isDisabled: this.productState.isPrintingSelected || !this.productState.productDetail.product.plainGoodFastShipping,
          isHidden: !supportPlainGoodFastShipping,
          isBuying: SHIPPING_OPTIONS.SAME_DAY
        }
      ].filter(option => !option.isHidden)
    },
    selectedShippingOption: {
      get(): SHIPPING_OPTIONS {
        return !this.isFastShippingSelected ? SHIPPING_OPTIONS.NORMAL
          : this.productState.isPrintingSelected ? SHIPPING_OPTIONS.NEXT_DAY
          : SHIPPING_OPTIONS.SAME_DAY
      }
    }
  },
  methods: {
    onChangeShippingOption(option: SHIPPING_OPTIONS) {
      const isFastShipping = option !== SHIPPING_OPTIONS.NORMAL
      this.$emit('onChangeShippingOption', isFastShipping, option)
    }
  }
})
